import { cn } from "@/lib/utils";

export function Badge({
  children,
  className,
  tone = "default"
}: {
  children: React.ReactNode;
  className?: string;
  tone?: "default" | "deal" | "prime" | "success";
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-sm px-2 py-1 text-xs font-bold",
        tone === "default" && "bg-slate-100 text-[#172B3A] dark:bg-white/10 dark:text-slate-200",
        tone === "deal" && "bg-[#FF8A00] text-white font-bold shadow-2xs",
        tone === "prime" && "bg-[#087DB5]/10 text-[#073B70] border border-[#087DB5]/20 dark:bg-[#087DB5]/20 dark:text-cyan-200",
        tone === "success" && "bg-[#00B7B0]/15 text-[#073B70] border border-[#00B7B0]/30 dark:bg-[#00B7B0]/20 dark:text-teal-200",
        className
      )}
    >
      {children}
    </span>
  );
}
